import React from "react";
import ReactDOM from "react-dom";
import  App  from "./Container/App";
import "./assets/App.css";
import 'font-awesome/css/font-awesome.min.css';

ReactDOM.render(<App />, document.getElementById("root"))
